import type { MouseEvent } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@ndd/ui";

/**
 * The shared "Discard unsaved changes?" gate driven by `useFormDirtyGuard`.
 * Same copy and treatment as the meeting-note-form dialog: a "Keep editing"
 * cancel and a destructive "Discard changes" action.
 */
export function DiscardChangesDialog({
  open,
  onOpenChange,
  onDiscard,
  disabled,
  description,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  description: string;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard unsaved changes?</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={disabled}>Keep editing</AlertDialogCancel>
          <AlertDialogAction
            disabled={disabled}
            className="bg-error text-white hover:bg-error/90"
            onClick={onDiscard}
          >
            Discard changes
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
